import {
  ChangeDetectionStrategy,
  Component,
  input,
  signal,
} from '@angular/core';
import { ReactiveFormsModule } from '@angular/forms';
import { AdminUser } from '@features/admin/admin-users/admin-user.interface';
import { UserGamesHistoryComponent } from '@features/user/user-history/user-games-history/user-games-history.component';
import { UserTransactionsHistoryComponent } from '@features/user/user-history/user-transactions-history/user-transactions-history.component';
import { SvgIconComponent } from 'angular-svg-icon';
import {
  NgpTabButton,
  NgpTabList,
  NgpTabPanel,
  NgpTabset,
} from 'ng-primitives/tabs';
import { AdminUserProfileComponent } from '@features/admin/admin-users/admin-user-profile/admin-user-profile.component';
import { AdminUserTicketsTableComponent } from '@features/admin/admin-support/admin-user-tickets-table/admin-user-tickets-table.component';
import { Inputs } from '@core/types/utils.type';

type TabVariant =
  | 'profile'
  | 'games-history'
  | 'transactions-history'
  | 'tickets';
interface TabItem {
  label: string;
  icon: string;
  key: TabVariant;
}

@Component({
  selector: 'app-admin-user-modal',
  imports: [
    SvgIconComponent,
    NgpTabset,
    NgpTabList,
    NgpTabButton,
    NgpTabPanel,
    ReactiveFormsModule,
    UserGamesHistoryComponent,
    UserTransactionsHistoryComponent,
    AdminUserProfileComponent,
    AdminUserTicketsTableComponent,
  ],
  templateUrl: './admin-user-modal.component.html',
  styleUrl: './admin-user-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex',
  },
})
export class AdminUserModalComponent {
  user = input.required<AdminUser>();
  hidePrimaryData =
    input<Inputs<AdminUserProfileComponent>['hidePrimaryData']>(false);

  readonly selectedTab = signal<TabVariant>('profile');

  tabs: TabItem[] = [
    {
      label: 'Profile',
      icon: 'assets/icons/shared/profile.svg',
      key: 'profile',
    },
    {
      label: 'Games History',
      icon: 'assets/icons/shared/clock.svg',
      key: 'games-history',
    },
    {
      label: 'Transactions History',
      icon: 'assets/icons/core/price.svg',
      key: 'transactions-history',
    },
    {
      label: 'Tickets',
      icon: 'assets/icons/shared/profile.svg',
      key: 'tickets',
    },
  ];
}
